/* =============================================================================
   pl-secciones.js — comportamiento de las secciones de landing / homepage
   · Interacciones (sin librería o con anime.js): pestañas, FAQ, antes/después,
     reels de video, carrusel de reseñas, "ver más".
   · Escenas de scroll (GSAP, vía motion.js → ONX.scenes): línea de tiempo,
     activos 3D, abanico 3D, manifiesto, sello de garantía.
   Un elemento lo anima UN solo motor.
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};
  var A = function () { return window.anime; };

  /* =============================================================== pestañas */
  function initTabs(root) {
    root.querySelectorAll('[data-pl-tabs]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var btns = box.querySelectorAll('.plt__btn'), panels = box.querySelectorAll('.plt__panel');
      var pill = box.querySelector('.plt__pill'), bar = box.querySelector('.plt__btns');
      function movePill(btn, instant) {
        if (!pill) return;
        var to = { left: btn.offsetLeft, width: btn.offsetWidth };
        if (instant || !A()) { pill.style.left = to.left + 'px'; pill.style.width = to.width + 'px'; return; }
        A().animate(pill, { left: to.left, width: to.width, duration: 520, ease: 'outElastic(1, .8)' });
      }
      function show(i) {
        btns.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-selected', k === i); });
        panels.forEach(function (p, k) {
          var on = k === i;
          p.classList.toggle('is-on', on);
          if (on && A()) {
            A().animate(p.querySelector('.plt__media'), { clipPath: ['inset(0 0 100% 0 round 18px)', 'inset(0 0 0% 0 round 18px)'], duration: 800, ease: 'outExpo' });
            A().animate(p.querySelectorAll('.plt__copy > *'), { opacity: [0, 1], y: [18, 0], duration: 600, delay: A().stagger(70, { start: 120 }), ease: 'outQuad' });
          }
        });
        movePill(btns[i]);
        if (bar && btns[i]) bar.scrollTo({ left: btns[i].offsetLeft - 20, behavior: 'smooth' });
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      requestAnimationFrame(function () { if (btns[0]) movePill(btns[0], true); });
      window.addEventListener('resize', function () { var on = box.querySelector('.plt__btn.is-on'); if (on) movePill(on, true); });
    });
  }

  /* ==================================================================== FAQ */
  function initFaq(root) {
    root.querySelectorAll('[data-pl-faq] .plf__item').forEach(function (it) {
      if (it._ok) return; it._ok = true;
      var q = it.querySelector('.plf__q'), a = it.querySelector('.plf__a'), inner = it.querySelector('.plf__a-in');
      q.addEventListener('click', function () {
        var open = !it.classList.contains('is-open');
        it.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open);
        var h = inner.offsetHeight;
        if (A()) {
          A().animate(a, { height: open ? [0, h] : [h, 0], duration: open ? 520 : 380, ease: open ? 'outExpo' : 'inOutQuad',
            onComplete: function () { if (open) a.style.height = 'auto'; } });
          if (open) A().animate(inner, { opacity: [0, 1], y: [-8, 0], duration: 500, ease: 'outQuad' });
        } else a.style.height = open ? 'auto' : '0px';
      });
    });
  }

  /* ========================================================= antes/después */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-pl-ba]').forEach(function (f) {
      if (f._ok) return; f._ok = true;
      var drag = false;
      function set(x) {
        var r = f.getBoundingClientRect();
        var p = Math.max(3, Math.min(97, (x - r.left) / r.width * 100));
        f.style.setProperty('--pos', p + '%');
      }
      f.addEventListener('pointerdown', function (e) { drag = true; f.setPointerCapture(e.pointerId); set(e.clientX); });
      f.addEventListener('pointermove', function (e) { if (drag) set(e.clientX); });
      f.addEventListener('pointerup', function () { drag = false; });
      f.addEventListener('pointercancel', function () { drag = false; });
      // pista: al verla por primera vez el divisor se mueve solo, para que se entienda que se arrastra
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        if (!A()) return;
        var o = { p: 50 };
        A().animate(o, { p: [50, 28, 72, 50], duration: 2200, delay: 300, ease: 'inOutSine',
          onUpdate: function () { if (!drag) f.style.setProperty('--pos', o.p + '%'); } });
      }, { threshold: 0.5 });
      io.observe(f);
    });
  }

  /* ========================================================== reels de video */
  function initReels(root) {
    root.querySelectorAll('[data-pl-reels]').forEach(function (row) {
      if (row._ok) return; row._ok = true;
      var vids = row.querySelectorAll('video');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            if (v.preload === 'none') v.preload = 'metadata';
            v.play().catch(function () {});
          } else v.pause();
        });
      }, { threshold: [0, 0.6, 1] });
      vids.forEach(function (v) { io.observe(v); });
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.plv__sound'); if (!b) return;
        var v = b.parentElement.querySelector('video');
        vids.forEach(function (o) { if (o !== v) o.muted = true; });
        v.muted = !v.muted; b.classList.toggle('is-on', !v.muted);
      });
    });
  }

  /* ============================================ carrusel de reseñas y "ver más" */
  function initRows(root) {
    root.querySelectorAll('[data-pl-row]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var row = box.querySelector('.plr__row');
      var step = function () { var c = row.querySelector('.plr__card'); return c ? c.offsetWidth + 14 : row.clientWidth * 0.8; };
      var p = box.querySelector('[data-prev]'), n = box.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-pl-more]').forEach(function (btn) {
      if (btn._ok) return; btn._ok = true;
      btn.addEventListener('click', function () {
        var wall = document.getElementById(btn.getAttribute('data-pl-more'));
        wall.classList.add('is-all'); btn.hidden = true;
        if (A()) A().animate(wall.querySelectorAll('.is-extra'), { opacity: [0, 1], y: [24, 0], duration: 600, delay: A().stagger(60), ease: 'outQuad' });
      });
    });
  }

  /* ============================================== inclinación con el mouse */
  function initTilt(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('[data-tilt]').forEach(function (c) {
      if (c._tilt) return; c._tilt = true;
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 10).toFixed(2) + 'deg) translateZ(0)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  function init(root) { root = root || document; initTabs(root); initFaq(root); initBeforeAfter(root); initReels(root); initRows(root); initTilt(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ======================================================= ESCENAS (GSAP) */

  // Línea de tiempo: la línea se llena con el scroll y cada paso se enciende al alcanzarlo
  ONX.scenes['pl-timeline'] = function (el, gsap) {
    var fill = el.querySelector('.plw__fill'), steps = el.querySelectorAll('.plw__step');
    gsap.to(fill, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: el, start: 'top 70%', end: 'bottom 60%', scrub: 0.5 } });
    steps.forEach(function (s) {
      gsap.from(s, { opacity: 0.25, x: 16, duration: 0.6, ease: 'power2.out',
        scrollTrigger: { trigger: s, start: 'top 72%', toggleActions: 'play none none reverse',
          onEnter: function () { s.classList.add('is-on'); }, onLeaveBack: function () { s.classList.remove('is-on'); } } });
    });
  };

  // Activos: las tarjetas giran en 3D hasta quedar de frente, escalonadas
  ONX.scenes['pl-activos'] = function (el, gsap, ST, env) {
    var cards = el.querySelectorAll('.pla__card');
    gsap.fromTo(cards, { rotateY: env.mobile ? -35 : -55, rotateX: 10, z: -120, opacity: 0, transformOrigin: '0% 50%' },
      { rotateY: 0, rotateX: 0, z: 0, opacity: 1, stagger: 0.15, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 78%', end: 'top 25%', scrub: 0.8 } });
    // la imagen de cada activo flota un poco más lento que su tarjeta (profundidad)
    el.querySelectorAll('.pla__img').forEach(function (img) {
      gsap.fromTo(img, { y: 26 }, { y: -26, ease: 'none', scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 0.6 } });
    });
  };

  // Abanico 3D de productos (homepage): apiladas → se abren en abanico con el scroll
  ONX.scenes['pl-abanico'] = function (el, gsap, ST, env) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('.plan__card'));
    var n = cards.length, mid = (n - 1) / 2;
    var spread = env.mobile ? 22 : 70;               // % del ancho de la tarjeta entre cada una
    cards.forEach(function (c, i) {
      gsap.set(c, { zIndex: 10 + i, rotateZ: (i - mid) * 2, y: i * -4, rotateY: 0, xPercent: 0, z: -i * 10 });
    });
    var tl = gsap.timeline({ scrollTrigger: { trigger: el, start: 'top top', end: 'bottom bottom', scrub: 0.7 } });
    cards.forEach(function (c, i) {
      var d = i - mid;
      tl.to(c, { xPercent: d * spread, rotateZ: d * (env.mobile ? 6 : 7), rotateY: d * -14, y: Math.abs(d) * 22, z: -Math.abs(d) * 60,
        ease: 'power2.inOut', duration: 1 }, 0);
    });
    tl.from(el.querySelector('.plan__head'), { opacity: 0, y: 30, duration: 0.4 }, 0);
    tl.to({}, { duration: 0.5 });
  };

  // Manifiesto: las palabras se encienden conforme bajas
  ONX.scenes['pl-manifiesto'] = function (el, gsap) {
    var w = el.querySelectorAll('.plm__w');
    gsap.to(w, { opacity: 1, stagger: 0.08, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top 75%', end: 'bottom 45%', scrub: 0.4 } });
  };

  // Sello de garantía: gira en 3D con el scroll
  ONX.scenes['pl-sello'] = function (el, gsap) {
    var s = el.querySelector('.plg__seal-in');
    gsap.fromTo(s, { rotateY: -180, rotateZ: -20, scale: 0.6 }, { rotateY: 0, rotateZ: 0, scale: 1, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 85%', end: 'top 40%', scrub: 0.8 } });
  };
})();
